module.exports = __webpack_public_path__ + "img/logo-gu.750a3f0e.png";